import * as XLSX from "xlsx";

/**
 * Generate and download a template xlsx file for account import
 */
export function downloadAccountTemplate(companyName?: string): void {
  const wb = XLSX.utils.book_new();

  // Instructions sheet
  const instructions = [
    ["INSTRUCCIONES PARA IMPORTAR PLAN DE CUENTAS"],
    [""],
    ["1. FORMATO DEL ARCHIVO:"],
    ["   - Use la hoja 'Cuentas' para agregar las cuentas"],
    ["   - No modifique los nombres de las columnas"],
    ["   - Guarde el archivo como Excel (.xlsx) o CSV"],
    [""],
    ["2. CAMPOS REQUERIDOS:"],
    ["   - Codigo: Código único de la cuenta (ej: 1101001)"],
    ["   - Nombre: Nombre descriptivo de la cuenta"],
    ["   - Tipo: Tipo de cuenta (ver valores válidos abajo)"],
    [""],
    ["3. TIPOS DE CUENTA VÁLIDOS:"],
    ["   - activo: Cuentas de activo (bienes y derechos)"],
    ["   - pasivo: Cuentas de pasivo (obligaciones)"],
    ["   - patrimonio: Cuentas de patrimonio (capital)"],
    ["   - ingreso: Cuentas de ingreso (ventas, servicios)"],
    ["   - gasto: Cuentas de gasto (costos, gastos operacionales)"],
    [""],
    ["4. NOTAS IMPORTANTES:"],
    ["   - El código debe ser único por empresa"],
    ["   - Si el código ya existe, la fila será omitida"],
    ["   - Las filas con errores no serán importadas"],
    [""],
    ["5. EJEMPLOS DE CÓDIGOS:"],
    ["   - 1101001: Caja"],
    ["   - 1101002: Banco Estado"],
    ["   - 2101001: Proveedores"],
    ["   - 3101001: Capital Social"],
    ["   - 4101001: Ventas"],
    ["   - 5101001: Costo de Ventas"],
  ];

  const instructionsSheet = XLSX.utils.aoa_to_sheet(instructions);
  instructionsSheet["!cols"] = [{ wch: 60 }];
  XLSX.utils.book_append_sheet(wb, instructionsSheet, "Instrucciones");

  // Data sheet with example rows
  const data: (string | number)[][] = [
    ["Codigo", "Nombre", "Tipo"],
    ["1101001", "CAJA", "activo"],
    ["1101002", "FONDO FIJO", "activo"],
    ["1101003", "BANCO ESTADO", "activo"],
    ["1102001", "CLIENTES", "activo"],
    ["1103001", "EXISTENCIAS", "activo"],
    ["2101001", "PROVEEDORES", "pasivo"],
    ["2102001", "OBLIGACIONES BANCARIAS", "pasivo"],
    ["3101001", "CAPITAL SOCIAL", "patrimonio"],
    ["3102001", "UTILIDADES RETENIDAS", "patrimonio"],
    ["4101001", "VENTAS NACIONALES", "ingreso"],
    ["4101002", "VENTAS EXPORTACION", "ingreso"],
    ["5101001", "COSTO DE VENTAS", "gasto"],
    ["5102001", "GASTOS ADMINISTRATIVOS", "gasto"],
    ["5103001", "GASTOS DE VENTAS", "gasto"],
  ];

  const dataSheet = XLSX.utils.aoa_to_sheet(data);
  dataSheet["!cols"] = [
    { wch: 15 }, // Codigo
    { wch: 40 }, // Nombre
    { wch: 15 }, // Tipo
  ];
  XLSX.utils.book_append_sheet(wb, dataSheet, "Cuentas");

  // Generate filename
  const date = new Date().toISOString().split("T")[0];
  const filename = companyName
    ? `plantilla_cuentas_${companyName.toLowerCase().replace(/\s+/g, "_")}_${date}.xlsx`
    : `plantilla_cuentas_${date}.xlsx`;

  XLSX.writeFile(wb, filename);
}
